import React from "react";
import {AppStaticDropdown} from "./AppStaticDropdown";
import {appCurrenciesSelector} from "../slices/appSlice";
import {useSelector} from "react-redux";

export const CurrenciesDropdown = ({value, onChange, disabled = false}) => {
  const currencies = useSelector(appCurrenciesSelector);

  return <AppStaticDropdown
    value={value}
    choices={currencies}
    choiceValue={choice => choice.code}
    choiceLabel={choice => choice.name}
    choiceDisplay={CurrencyChoiceDisplay}
    onChange={onChange}
    disabled={disabled}
  />;
};

const CurrencyChoiceDisplay = choice => <div>{choice.name}</div>;
